import styled from "styled-components";

export const PreviewLabel = styled.div`
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
`;

export const WhatsappBackground = styled.div`
    background-color: #efeae2;
    border-radius: 8px;
    padding: 24px 16px;
    min-height: 260px;
    display: flex;
    align-items: flex-start;
`;

export const WhatsappBubble = styled.div`
    position: relative;
    margin-left: 8px;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 8px 12px 20px 12px;
    max-width: 100%;
    white-space: pre-wrap;
    word-break: break-word;

    &::before {
        content: "";
        position: absolute;
        left: -10px;
        bottom: 0;
        width: 20px;
        height: 24px;
        background-color: #ffffff;
        clip-path: polygon(100% 0, 100% 100%, 0 100%, 55% 70%);
    }
`;

export const WhatsappTitle = styled.div`
    font-weight: 700;
    margin-bottom: 4px;
`;

export const WhatsappPlaceholder = styled.span`
    color: #8696a0;
`;

export const WhatsappTime = styled.div`
    position: absolute;
    bottom: 6px;
    right: 12px;
    font-size: 11px;
    color: #8696a0;
`;

export const AppNotificationBackground = styled.div`
    background-color: #000000;
    border-radius: 8px;
    padding: 16px;
    min-height: 260px;
`;

export const AppNotificationCard = styled.div`
    background-color: #f2f2f7;
    border-radius: 16px;
    padding: 12px 14px;
`;

export const AppNotificationHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #8e8e93;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
`;

export const AppNotificationTitle = styled.div`
    font-weight: 700;
    margin-bottom: 2px;
`;

export const AppNotificationBody = styled.div`
    white-space: pre-wrap;
    word-break: break-word;
    color: #1c1c1e;
`;

export const AppNotificationPlaceholder = styled.span`
    color: #a1a1a6;
`;

export const FormatHint = styled.div`
    margin-top: 8px;
    font-size: 12px;
    color: #8c8c8c;
`;
